<mat-dialog-content class="d-flex flex-col">
    @if (currentMedia) {
        <div class="flex-row flex-space-between">
            <div>
                <mat-card-header class="p-0">
                    @if (currentMedia?.title) {
                        <mat-card-title>
                            <h3 class="m-0 bold" mat-dialog-title>{{ currentMedia?.title }}</h3>
                        </mat-card-title>
                    }
                </mat-card-header>
            </div>
            <div class="float-end">
                <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();"
                        class="mat-dialog-close " mat-dialog-close
                        mat-icon-button
                        matTooltip="Close Window">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <div [class.commentControl]="commenting || flagging" class="d-flex flex-row mobile-col justify-content-center">
            @if (commenting) {
                <app-comments (comment)="sendComment($event)"
                              [comments]="this.media[this.index].comments"
                              [reLoading]="commentsLoading"
                              class="flex-grow"></app-comments>
            }
            @if (flagging) {
                <div class="leftSection">
                    <form [formGroup]="flagForm" class="formFieldContainer ">
                        <h3>Flag Media</h3>
                        <mat-form-field appearance="outline" class="w-100 noBottomPadding" color="primary">
                            <mat-label>Feedback Type</mat-label>
                            <select formControlName="category" matNativeControl>
                                @for (category of categories; track category) {
                                    <option [value]="category">{{ category }}</option>
                                }
                            </select>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Title</mat-label>
                            <input formControlName="title" matInput placeholder="Title">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Description</mat-label>
                            <textarea formControlName="description" matInput
                                      maxlength="400"></textarea>
                        </mat-form-field>
                        <div class="d-flex flex-space-around">
                            <button (click)="flagging =!flagging" (keyup.enter)="flagging =!flagging"
                                    class="mat-elevation-z2" color="warn"
                                    mat-raised-button
                                    matTooltip="Cancel flag">
                                Cancel
                            </button>
                            <button (click)="flagMedia()" (keyup.enter)="flagMedia()" [disabled]="flagForm.invalid"
                                    class="mat-elevation-z2"
                                    color="primary" mat-raised-button
                                    matTooltip="Submit Flag">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            }
            <div class="flex-col w-100 p-10">
                <app-media-display
                        (click)="currentMedia.file_type == 'image' ? openFullScreen():''"
                        (download)="download()"
                        (pauseSlideshow)="stopSlideshow()" [file]="currentMedia"></app-media-display>
                @if (currentMedia?.description) {
                    <small>Description: {{ currentMedia?.description }}</small>
                }
                @if (currentMedia.user) {
                    <small>Uploaded by: {{ currentMedia.user| nameDisplay }}</small>
                }
                <small>Uploaded on: {{ currentMedia.created_date | date }}</small>
            </div>
        </div>
    }
    @if (!currentMedia) {
        <div class="centerLoading">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
    }
</mat-dialog-content>
@if (currentMedia) {
    <mat-dialog-actions>
        @if (loading) {
            <mat-progress-bar class="col-12" color="primary" mode="indeterminate"></mat-progress-bar>
        }
        <div class="flex-row flex-space-between w-100 align-items-center">
            @if (media && this.media.length > 1) {
                <button (click)="move(true)" (keyup.enter)="move(true)"
                        aria-label="Show Previous Item"
                        color="primary" mat-icon-button
                        matTooltip="Previous item">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
            }
            <div class="btnRow">
                @if (currentMedia) {
                    <div [matTooltip]="this.currentMedia.is_processing? 'We\'re processing this memory. Please check back later' : 'Download'">
                        <button (click)="download()" (keyup.enter)="download()"
                                [disabled]="this.currentMedia.is_processing"
                                aria-label="Download" class="mat-elevation-z2 m-0"
                                color="primary" mat-mini-fab>
                            <mat-icon>get_app</mat-icon>
                        </button>
                    </div>
                }
                @if ((permission == 'View, Comment and Add' || permission == 'Add but not View or Comment') && !this.user.role.raa_is_limited && this.canEdit) {
                    <button (click)="editItem()" (keyup.enter)="editItem()"
                            aria-label="Edit Media" class="mat-elevation-z2 m-0" color="primary" mat-mini-fab
                            matTooltip="Edit">
                        <mat-icon>edit</mat-icon>
                    </button>
                }
                @if (canFavourite && !isRaa) {
                    <button (click)="favouriteMedia()" (keyup.enter)="favouriteMedia()"
                            [attr.aria-label]="currentMedia.is_favourite ? 'Unfavourite Media' : 'Favourite Media'"
                            [matTooltip]="currentMedia.is_favourite ? 'Unfavourite Media' : 'Favourite Media'"
                            class="mat-elevation-z2 m-0" color="primary" mat-mini-fab>
                        @if (!currentMedia.is_favourite) {
                            <mat-icon>
                                favorite_border
                            </mat-icon>
                        }
                        @if (currentMedia.is_favourite) {
                            <mat-icon class="mat-accent" color="accent">
                                favorite
                            </mat-icon>
                        }
                    </button>
                }
                @if ((permission == 'View, Comment and Add' || permission == 'View and Comment') && allowsComments) {
                    <button (click)="toggleCommenting()" (keyup.enter)="toggleCommenting()"
                            [attr.aria-label]="commenting ? 'Hide Comments' : 'Show Comments'"
                            [attr.aria-pressed]="commenting"
                            [color]="!this.commenting? 'primary' : 'accent'"
                            [matBadgeHidden]="currentMedia.comment_count < 1"
                            [matBadge]="currentMedia.comment_count"
                            [matTooltip]="commenting ? 'Hide Comments' : 'Show Comments'"
                            class="mat-elevation-z2 m-0" color="primary"
                            mat-mini-fab matBadgeColor="accent">
                        <mat-icon>
                            chat
                        </mat-icon>
                    </button>
                }
                @if (permission == 'View, Comment and Add' && !this.user.role.raa_is_limited) {
                    <button (click)="duplicateMedia()" (keyup.enter)="duplicateMedia()"
                            [matTooltip]="'Duplicate Media'"
                            aria-label="Duplicate Media"
                            class="mat-elevation-z2 m-0"
                            color="primary" mat-mini-fab>
                        <mat-icon>filter_none</mat-icon>
                    </button>
                }
                @if (this.user.role.can_hide_media && !currentMedia.hidden) {
                    <button (click)="hideMedia()" (keyup.enter)="hideMedia()"
                            [matTooltip]="'Hide Media'"
                            aria-label="Hide Media"
                            class="mat-elevation-z2 m-0"
                            color="warn" mat-mini-fab>
                        <mat-icon>visibility_off</mat-icon>
                    </button>
                }
                @if (this.user.role.can_permanently_delete) {
                    <button (click)="deleteMedia()" (keyup.enter)="deleteMedia()"
                            aria-label="Delete Media"
                            class="mat-elevation-z2 m-0"
                            color="warn"
                            mat-mini-fab matTooltip="Delete Media">
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                }
                @if (this.user.role.can_hide_media && currentMedia.hidden) {
                    <button (click)="unHideMedia()" (keyup.enter)="unHideMedia()"
                            aria-label="Restore Media"
                            class="mat-elevation-z2 m-0"
                            color="accent"
                            mat-mini-fab matTooltip="Restore Media">
                        <mat-icon>restore_from_trash</mat-icon>
                    </button>
                }
                <button (click)="toggleFlagMedia()" (keyup.enter)="toggleFlagMedia()"
                        [attr.aria-label]="flagging ? 'Close Flag Media' : 'Flag Form'"
                        [attr.aria-pressed]="flagging"
                        [color]="!this.flagging? 'primary' : 'accent'"
                        [matTooltip]="flagging ? 'Close Flag Media' : 'Flag Form'"
                        class="mat-elevation-z2 m-0" color="warn"
                        mat-mini-fab>
                    <mat-icon>flag</mat-icon>
                </button>
                @if (media && this.media.length > 1) {
                    <button (click)="toggleSlideshow()" (keyup.enter)="toggleSlideshow()"
                            [attr.aria-label]="slideshowInProgress ? 'Pause Slideshow' : 'Play Slideshow'"
                            [attr.aria-pressed]="slideshowInProgress"
                            [color]="!this.slideshowInProgress? 'primary' : 'accent'"
                            [matTooltip]="slideshowInProgress ? 'Pause Slideshow' : 'Play Slideshow'"
                            class="mat-elevation-z2 m-0"
                            mat-mini-fab>
                        @if (!slideshowInProgress) {
                            <mat-icon>play_arrow</mat-icon>
                        }
                        @if (slideshowInProgress) {
                            <mat-icon>stop</mat-icon>
                        }
                    </button>
                }
                @if (!this.isMobile && media && this.media.length > 1) {
                    <button (click)="openKeyboardShortcuts()" (keyup.enter)="openKeyboardShortcuts()"
                            class="mat-elevation-z2 m-0"
                            color="primary"
                            mat-mini-fab matTooltip="View Keyboard Shortcuts">
                        <mat-icon>keyboard</mat-icon>
                    </button>
                }
                @if (currentMedia.file_type == 'image' || currentMedia.file_type == 'document') {
                    <button (click)="openFullScreen()"
                            (keyup.enter)="openFullScreen()"
                            class="mat-elevation-z2 m-0"
                            color="primary"
                            mat-mini-fab matTooltip="View Full Screen">
                        <mat-icon>fullscreen</mat-icon>
                    </button>
                }
            </div>
            @if (media && this.media.length > 1) {
                <button (click)="move()" (keyup.enter)="move()"
                        aria-label="Show Next Item" cdkFocusInitial
                        class="ms-auto"
                        color="primary"
                        mat-icon-button matTooltip="Next item">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
            }
        </div>
    </mat-dialog-actions>
}

